import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Dimmer, Loader, Image, Segment, Button } from 'semantic-ui-react'
import { QryOutputHeader } from './qryOutputHeader';
import ResultOutput from './resultOutput';
import { fileQryFunction } from './actions/qryInputActions';
import MockResponse  from './mockResponse';
import store from './store';
import _ from 'lodash';
export class QueryOutput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            "enableProceedToPsc": false,
            storeTick: 0,
        }
        this.enableDisablePsc = this.enableDisablePsc.bind(this);
    }
    componentDidMount(){
        // Non-modal job-status tabs need this so GET_*_QUERY_RESPONSE results display
        if (this.props.nonModalWindow || this.props.hideLeftPanel) {
            window.qryTimeout = false;
        }
        this._unsubscribeStore = store.subscribe(() => {
            this.setState((prev) => ({ storeTick: prev.storeTick + 1 }));
        });
    }
    componentWillUnmount(){
        window.qryTimeout = true;
        if (this._unsubscribeStore) {
            this._unsubscribeStore();
            this._unsubscribeStore = null;
        }
    }
    enableDisablePsc(status){
         (this.state.enableProceedToPsc!==status) &&
            this.setState({
                "enableProceedToPsc": status
            })
    }
    printDiv() {
        var printContents = document.getElementById("printableArea").innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;
   }


    render() {
        const lowerEnv = (window.BASE_URL || "").match(/(staging|dev|stage|qat)/g);

        // Always prefer the live qry store — connect props can be stale with custom Provider context
        const storeQry = store.getState().QryInput || {};
        const requestid = storeQry.requestid;
        const mockResponseRequired = storeQry.mockResponseRequired;
        const loading = !!storeQry.loading;
        const qryInput = storeQry.qryInput;
        const qryOutput = storeQry.qryOutput || { outputType: '', responseParams: {} };
        const saveTo = storeQry.saveTo;

        let justnow = this.props.startTimexx && this.props.startTimexx + 1000 > Date.now();
        const hasResults = !_.isEmpty(_.get(qryOutput, 'responseParams'));
        const isMidForm = this.props.launchFrom === 'MF_FORM';
        // Customs Queries: ignore leftover qryType after close unless there are results/loading.
        // MID manufacturer modal: qryType is always MID so Add Manually can render with empty results.
        const qryType = this.props.qryType
            || (isMidForm && qryInput ? qryInput.qryType : null)
            || ((hasResults && qryInput && !justnow) ? qryInput.qryType : null)
            || ((loading && qryInput && !justnow) ? qryInput.qryType : null);
        const launchFrom  = this.props.launchFrom || null;
        const startPsc  = this.props.startPsc || null;
        const closeModal = this.props.closeModal;

        return (
            <React.Fragment>
            <Grid className={`brokerQryOutput`}>
                {
                    qryType &&
                    <Grid.Row className='headerRow'>
                        <Grid.Column width={16}>
                            <QryOutputHeader
                            runAgainClicked={this.props.runAgainClicked}
                            runningAgain={this.props.runningAgain}
                            enableProceedToPsc={this.state.enableProceedToPsc}
                            closeModal={closeModal}
                            launchFrom={launchFrom} startPsc={startPsc}
                            qryType={qryType}
                            adminAccountReadonly={this.props.adminAccountReadonly}
                            queryRanFor={this.props.queryRanFor}
                            bolIdData={this.props.bolIdData}
                            startedReconcile={this.props.startedReconcile}
                            startReconcileClicked={this.props.startReconcileClicked}
                            processReconcile={this.props.processReconcile}/>
                        </Grid.Column>
                    </Grid.Row>
                }
                <Grid.Row>
                    <Grid.Column width={16}>
                        {
                            loading &&  <React.Fragment><Segment style={{"width": "100%"}}>
                            <Dimmer active inverted>
                                <Loader inverted content='Please Wait...' />
                            </Dimmer>
                            <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
                        </Segment><br /><br /> </React.Fragment>
                        }

                        {
                            (!loading && lowerEnv && mockResponseRequired && requestid)?
                             <React.Fragment><br /><br /><br /><br /><MockResponse
                                        {...this.props}
                                        qryType={qryType}
                                        kxUser={this.props.kxUser}
                                        requestid={requestid}
                                        qryOutput={qryOutput}
                                        qryInput={qryInput}
                                        shipmentId={this.props.shipId}
                                    /> </React.Fragment> : ((!loading && lowerEnv && !mockResponseRequired) ?
                                        <ResultOutput  {...this.props}
                                            userType={this.props.userType}
                                            saveTo={saveTo}
                                            launchFrom={this.props.launchFrom}
                                            qryOutput={qryOutput}
                                            qryInput={qryInput}
                                            componentRef={this.props.componentRef}
                                            enableDisablePsc={this.enableDisablePsc}
                                            set_MF_Form_Data={this.props.set_MF_Form_Data}
                                            qryType={qryType} /> : '')
                            }
                            {
                                (!loading && !lowerEnv && !mockResponseRequired) ?
                                    <ResultOutput
                                        {...this.props}
                                        userType={this.props.userType}
                                        saveTo={saveTo}
                                        launchFrom={this.props.launchFrom}
                                        qryOutput={qryOutput}
                                        qryInput={qryInput}
                                        componentRef={this.props.componentRef}
                                        enableDisablePsc={this.enableDisablePsc}
                                        set_MF_Form_Data={this.props.set_MF_Form_Data}
                                        qryType={qryType} /> : ''
                            }
                        </Grid.Column>
                    </Grid.Row>
            </Grid>
            </React.Fragment>

        )
    }

}
const mapDispatchToProps = {
    fileQryFunction
}

const mapStateToProps = (state, props) => {
   //console.log("mapStateToProps===", store.getState());
    let _state = state.QryInput || store.getState().QryInput;
    return ({
        requestId: _state.requestid,
        mockResponseRequired: _state.mockResponseRequired,
        loading: _state.loading,
        qryInput: _state.qryInput,
        qryOutput: _state.qryOutput,
        saveTo: _state.saveTo
    })
}

export default connect(
mapStateToProps,
mapDispatchToProps
)(QueryOutput)
